import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-xtheme-vv',
  templateUrl: './xtheme-vv.component.html',
  styleUrls: ['./xtheme-vv.component.styl']
})
export class XthemeVvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
